$(document).ready(function () {
    // get country code
    var countryCode = $('html').data('countrycode');

    if (document.getElementById('resendResetPasswordForm')) {
        // resend reset password;
        var resend = {
            el: document.getElementById('resendResetPasswordForm'),
            init: function () {
                resend.addEvent();
                resend.getCaptcha();
                
            },
            appendCaptcha: function(html){
                $('#captchaBox').empty();
                $('#captchaBox').append(html);
            },
            getCaptcha: function( showErrorCbFn ){
                if (typeof showErrorCbFn !== 'function'){
                    showErrorCbFn = new Function();
                }
                var $form = $(resend.el);
                var captchaUrl = $form.data('captchaUrl');
    
                if(!captchaUrl) return false;
    
                $.ajax({
                    type: "post",
                    url: captchaUrl,
                    async: false,
                    dataType: "json",
                    xhrFields: {
                        withCredentials: true
                    },
                    success: function(data) {
                        console.log(data);
                        //$(sgin.el).attr("data-action-url", data.captchaUrl).data("actionUrl", data.captchaUrl);
                        
                        if (!!data.captchaHtml){
                            var $csrf;
                            if ( $form.find('[name=csrfToken]').length ){
                                $csrf = $form.find('[name=csrfToken]').eq(0);
                                $csrf.val( data.csrfToken );
                            } else {
                                $csrf = $('<input type="hidden" name="csrfToken">');
                                $csrf.val( data.csrfToken );
                                $form.append( $csrf );
                            }
                            
                            resend.appendCaptcha(data.captchaHtml);
                            showErrorCbFn();
                            
                        }
                    },
                    error: function(request,status,error) {
                        console.log("status: "+status);
                        console.log("error: "+error);
    
                        alert('SYSTEM ERROR');
                    }
                });
    
    
            },
            errorReset: function(){
                var $field = $(resend.el).find('.field-block');
                var errorMsg = $field.find('.error-msg span');

                $field.removeClass('error');
                errorMsg.hide();
            },
            showError: function(_t, _target, _msg){
                var block = $(_t).parents(".field-block");
                block.addClass('error').find(_target).text(_msg).show().siblings().hide();
                $(_t).focus();
            },
            addEvent: function(){
                $(resend.el).find('.btn-area [type="submit"]').on({
                    'click': function (e) {
                        e.preventDefault();
                        resend.errorReset();

                        var $form = $(resend.el);
                        if ($form.checkValidation() == false ) {
                            return false;
                        }

                        if ($form.data('submitted') === true) {
                            return;                            
                        } else {                           
                            
                            var formSerializeArray = $form.serializeArray();
                            var object = {};
                            for (var i = 0; i < formSerializeArray.length; i++){
                                object[formSerializeArray[i]['name']] = formSerializeArray[i]['value'];
                            }
                            object["emailAddr"] = xssfilter( $form.find('#txtBoxEmail').val() );
                            

                            // email ajax validation                             
                            var ajaxUrl = $form.data('actionUrl');

                            $('body').trigger('ajaxLoadBefore');
                            $.ajax({
                                type: 'post',
                                url: ajaxUrl,
                                async: false,
                                dataType: 'json',
                                data: object,
                                xhrFields: {
                                    withCredentials: true
                                },
                                success: function(res) {
                                    console.log('res: ', res);

                                    if (res.result) {                                    
                                        resend.errorReset();
                                        $form.data('submitted', true);
                                        // 20200319 START 김우람 || BR email list modal
                                        if ( res.cpfListFlag == "Y" ){
                                            
                                            if ( res.resultList.length == 1){
                                                // 20200326 START 김우람 || BR email list form 키값추가
                                                if ( !$form.find('[name=emailCode]').length ){
                                                    $form.append('<input type="hidden" name="emailCode" />');
                                                }

                                                if ( !$form.find('[name=cpfListFlag]').length ){
                                                    $form.append('<input type="hidden" name="cpfListFlag" />');
                                                }

                                                if ( !$form.find('[name=sKey]').length ){
                                                    $form.append('<input type="hidden" name="sKey" />');
                                                }

                                                $form.find('[name=emailCode]').val( res.resultList[0].emailCode );
                                                $form.find('[name=cpfListFlag]').val( res.cpfListFlag );
                                                $form.find('[name=sKey]').val( res.sKey );
                                                // 20200326 END 김우람 || BR email list form 키값추가
                                                $form.submit();
                                            } else {
                                                var emailContainer = $('#modal_email_select').find('.period ul');
                                                emailContainer.empty();

                                                $.each(res.resultList , function( idx ){
                                                    var emailCode = this.emailCode;
                                                    var email = this.email;
                                                    var radioHtml = '<li><label class="radio-box" for="option_'+ idx +'">';
                                                    radioHtml += '<input type="radio" name="emailradio" id="option_'+ idx +'" value="'+ emailCode +'" />';
                                                    radioHtml += '<span class="radio-btn"></span><span class="text">'+ email +'</span>';
                                                    radioHtml += '</label></li>';                                                
                                                    emailContainer.append( $(radioHtml) );
                                                });

                                                var emailOkBtn = $('#modal_email_select').find('.email-list button');
                                                
                                                emailOkBtn.off().on('click', function(e){
                                                    e.preventDefault();
                                                    var checkedRadio = emailContainer.find('input:radio:checked');
                                                    // 20200325 START 김우람 || BR 이메일 리스트 버그 수정
                                                    if (!checkedRadio.length){
                                                        return;
                                                    }
                                                    // 20200325 END 김우람 || BR 이메일 리스트 버그 수정

                                                    // 20200326 START 김우람 || BR email list form 키값추가
                                                    if ( !$form.find('[name=emailCode]').length ){
                                                        $form.append('<input type="hidden" name="emailCode" />');
                                                    }
    
                                                    if ( !$form.find('[name=cpfListFlag]').length ){
                                                        $form.append('<input type="hidden" name="cpfListFlag" />');
                                                    }
    
                                                    if ( !$form.find('[name=sKey]').length ){
                                                        $form.append('<input type="hidden" name="sKey" />');
                                                    }
    
                                                    $form.find('[name=emailCode]').val( checkedRadio.val() );
                                                    $form.find('[name=cpfListFlag]').val( res.cpfListFlag );
                                                    $form.find('[name=sKey]').val( res.sKey );
                                                    // 20200326 END 김우람 || BR email list form 키값추가

                                                    $form.submit();
                                                });

                                                $('#modal_email_select').off().on('hide.bs.modal', function(){
                                                    $form.data('submitted', false);
                                                });

                                                $('#modal_email_select').modal();
                                            }
                                            
                                        } else {
                                            $form.submit();
                                        }
                                        // 20200319 END 김우람 || BR email list modal
                                        
                                    } else {      
                                    	// LGECI-541 start
            							if(document.getElementById('customizedCaptcha') ==  null || document.getElementById('customizedCaptcha') == undefined){
            								if( !!$('#g-recaptcha').val()){
            									reload_recaptcha_wrapper();
            								}
            							}
            							// LGECI-541 end
                                    	
                                    	// LGEPA-473 start : test

                                    	if( res.error.code == "1009"){ // LGEGMC-2186

                                    		var _htm = "<form action='' id='signinForm' method='post'>"
                                    			_htm += "<fieldset>";
                                    		    _htm += "<input type='hidden' id='txtBoxEmail' name='emailAddr' value='"+res.error.mail+"'>";
                                    		    _htm += "<input type='hidden' id='txtBoxPassword' name='password' value='abc1234!@'>";
                                    		    _htm += "<input type='hidden' name='submitData' value='"+ JSON.stringify( res )+"'>";
	                                    		_htm += "<input type='hidden' name='serverEnv' value='"+$("#resendResetPasswordForm").find("input[name='serverEnv']").val()+"'>";
	                                    		_htm += "</fieldset>";
	                                    		_htm += "</form>";
	                                    		
                                    		$('body').append(_htm);
                    						var form = $("#signinForm");
                    						form.attr("action",$("#resendResetPasswordForm").attr("action").replace("/forgotPassword","/login"));
                    						form.submit();
                                    		
                                    		return;
                                    	}
                                    	// LGEPA-473 end
                                    	
                                        if (!!res.error.captchaCodeTextBox){
                                            // validation fail

                                            resend.getCaptcha(function(){
                                                for (var key in res.error) {
                                                    var $field = $(resend.el).find('input[name="' + key + '"]');
                                                    
                                                    if ($field.length) {
                                                        resend.showError($field, '.ajax-msg', res.error[key]);
                                                    }
                                                }
                                            });
                                        } else {
                                            var $field = $(resend.el).find('.field-block');
                                            var errorMsg = $field.find('.error-msg .registered');

                                            $field.addClass('error');
                                            errorMsg.show();
                                        }
                                    }
                                },
                                error: function(request,status,error) {
                                    console.log("status: "+status);
                                    console.log("error: "+error);
                                },
                                complete: function(){
                                    $('body').trigger('ajaxLoadEnd');
                                }
                            });
                        }
                    }
                });
            }
        };
        resend.init();
    }

    if (document.getElementById('resetpasswordForm')) {
        // reset password;
        var pw = {
            el: document.getElementById('resetpasswordForm'),
            $error: null,
            init: function () {
                pw.$error = $(pw.el).find('.whole-error-msg');
                pw.addEvent();
                
                // Reset password | More details_Slide Toggle | 2019-12-02 yhjang
                // EMP 20220128 START 이상현 - event selector 수정
                // $('.password-info .btn-more').on('click', function() {
                $('.password-info button[aria-expanded]').on('click', function() {
                // EMP 20220128 END 이상현 
                    var $button = $(this),
                        $cont = $button.closest('.password-info').find('.password-info-cont');

                    if ($cont.is(':visible')) {
                        $button.attr('aria-expanded', false);
                        $cont.stop().slideUp();
                    } else {
                        $button.attr('aria-expanded', true);
                        $cont.stop().slideDown();
                    }
                });
            },
            beforeSubmit: function (e) {
                e.preventDefault();

                var _this = e.currentTarget;
                var _fields = {
                    new: $(_this).find('#txtBoxPassword').get(0),
                    newConfirm: $(_this).find('#txtBoxPasswordConfirm').get(0)
                };

                if ($(_this).checkValidation()) {
                    // test code
                    var test = true;
                    if(test){
                        console.log("test code for novalidate submit");
                        _this.submit();
                        return false;
                    } 
                    var url = _this.getAttribute('data-url');
					var param = xssfilter($(_this).serialize());
					var methodType = $(_this).data('ajaxMethod') || "post";
					if(_fields.new.value == _fields.newConfirm.value) {
                        $('body').trigger('ajaxLoadBefore');
                        $(pw.el).find('.whole-error-msg').hide().find('.match').hide();
						ajax.call(url, param, 'json', function(data){
							$('body').trigger('ajaxLoadEnd');
							if(!data.result) {
								if(!data.error) {
									// change fail
									$('#modal_change_my_password_fail').modal('show');
								} else {
                                    // invalid pw (fail)
                                    for(var key in data.error) {
                                        console.log(key);
                                        var $field = $(_this).find('input[name="'+key+'"]');
                                        pw.showError($field, '.ajax-msg', data.error[key]);
									}
								}
							}else {
								// change successed
								adobeTrackEvent('mylg-profile-update', {profile_update : 'password', page_event : {update_profile : true}});
								var url = _this.action;
								$('#modal_change_my_password_success').modal('show').find('.modal-footer button').on('click', function() {
									location.href = url;
								});
								/*
								setTimeout(function() {
									location.href = _this.action;
								}, 100);
								*/
							}
						},methodType);
					}else {
                        $(pw.el).find('.whole-error-msg').show().find('.match').show().siblings().hide();
					}
                }
            },
            showError: function(_t, _target, _msg){
				var block = $(_t).parents(".field-block");
				block.addClass('error').find(_target).text(_msg).show().siblings().hide();
			},
            // check: function (val) {
            //     var result = false;
            //     if (val.length > 7) {
            //         var n = /^.*(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).*$/;
            //         result = n.test(val);
            //     }
            //     return result;
            // },
            addEvent: function () {
                $(pw.el).on({
                    submit: pw.beforeSubmit
                });
                // $(pw.el).on({
                //     keydown: function (e) {
                //         if (e.keyCode == 13 && e.currentTarget.value != '') {
                //             console.log(pw.check($('#txtBoxPassword').val()));
                //             if (!pw.check($('#txtBoxPassword').val())) {
                //                 e.preventDefault();
                //                 $('#txtBoxPassword').parents('.field-block').addClass('error')
                //                     .find('.error-msg .invalid').show().siblings().hide();
                //             }
                //         }
                //     },
                //     /* Start of LGEUS-11769 */
                //     keyup: function (e) {
                //         if (e.currentTarget.value == '' || pw.check($('#txtBoxPassword').val())) {
                //             // remove password requirement
                //             e.preventDefault();
                //             $('#txtBoxPassword').parents('.field-block').removeClass('error');
                //         }
                //     }
                //     /* End of LGEUS-11769 */
                // }, '#txtBoxPassword, #txtBoxPasswordConfirm');
            }
        };
        pw.init();
    }

    // Start of LGEPA-173
    if (document.getElementById('preSignUpConfirmationForm')) {
        var preSignUpConfirmation = {
            el: document.getElementById('preSignUpConfirmationForm'),
            $error: null,
            init: function() {
                preSignUpConfirmation.addEvent();

            },
            beforeSubmit: function (e) {
                e.preventDefault();

                var _this = e.currentTarget;
                if ($(_this).checkValidation()) {
                    _this.submit();
                }
            },
            showError: function(_t, _target, _msg){
				var block = $(_t).parents(".field-block");
				block.addClass('error').find(_target).text(_msg).show().siblings().hide();
            },
            addEvent: function() {
                $(pw.el).on({
                    submit: pw.beforeSubmit
                });
            }
        };
        preSignUpConfirmation.init();
    }
    // End of LGEPA-173

    if (document.querySelector('.order-validation-form')) {
        var order = {
            el: document.querySelector('.order-validation-form'),
            init: function () {
                $(order.el).on({
                    submit: function (e) {
                        e.preventDefault();
                        var _this = e.currentTarget;
                        if ($(_this).checkValidation()) {
                            var url = _this.getAttribute('data-url');
                            var param = xssfilter($(_this).serialize());
                            var methodType = $(_this).data('ajaxMethod');

                            $('body').trigger('ajaxLoadBefore');
                            ajax.call(url, param, 'json', function (data) {
                                $('body').trigger('ajaxLoadEnd');
                                if (!data.result) {
                                    var key = Object.keys(data.error);
                                    var $target = $(_this[key]).closest('.field-block');
                                    $target.addClass('error').find('.unregistered').text(data.error[key[0]]).show().siblings().hide();
                                    // $(_this[key]).text(data.error[key[0]])
                                }
                            }, methodType);
                        }
                    }
                });
            }
        };

        order.init();
    }
    // mylg-signin-unregistered resend button
    if ( !!$('#unregistered-resend').length ){
        $('#unregistered-resend').on('show.bs.modal', function( e ){            
            var $btn = $(e.relatedTarget);
            var url = $btn.data().url;
            var email = getUrlParams().emailAddr;
            //$('body').trigger('ajaxLoadBefore');

            $.ajax({
                type: 'post',
                url: url,
                data: { "emailAddr": decodeURIComponent(xssfilter(email)) },
                dataType: 'json',
                xhrFields: {
                    withCredentials: true
                },
                success: function(data) {
                    //$('body').trigger('ajaxLoadEnd');
                    if (data.result) {
                    
                    }
                }
            });           

        });
    }

    var passwordView =  function(){
        var el = $('.password-util');
        var btn = el.find('.btn-eyes');
        var hide = el.find('.txt-hide').text();
        var show = el.find('.txt-show').text();
        var input = el.prev('input');

        // EMP 20220127 START 박지영 - Sign in 디자인 변경
        if(el.closest('.signin-wrap').length > 0 && el.closest('.signin-wrap').hasClass('signin-emp')) {
            input = el.parent().find('input');
        }
        // // EMP 20220127 END 박지영 - Sign in 디자인 변경

        btn.attr('aria-label', hide);
        
        btn.on('click', function(e){
            e.preventDefault();
            if($(this).is('.show')){
                $(this).removeClass('show').attr('aria-label', hide);
                input.attr('type', 'password');
            }else{
                $(this).addClass('show').attr('aria-label', show);
                input.attr('type', 'text');
            }
            /* LGEAU-207 : 20201127 add */
            btn.focus();
            /*// LGEAU-207 : 20201127 add */
        });
    }
    passwordView();
});